import { useLocation, useNavigate } from 'react-router-dom';

const useRemoveQueryParam = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (paramName: string) => {
    const currentParams = new URLSearchParams(location.search);
    currentParams.delete(paramName);

    const updatedQueryString = currentParams.toString();
    const updatedPath = updatedQueryString ? `${location.pathname}?${updatedQueryString}` : location.pathname;

    navigate(updatedPath, { replace: true });
  };
};

export default useRemoveQueryParam;
